import { Button } from "@progress/kendo-react-buttons";
import { Window } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";
import { Error } from "@progress/kendo-react-labels";
import axios from "axios";
import { useState } from "react";
import { userEmail, userEntries } from "../../Common/Store/CommonSignals";
import { Else, If } from "../../Common/UI/IfComponent";
import { Section } from "../../Common/UI/SectionComponent";
import ConfirmSplitEntryDialog from "../../Notification/ConfirmSplitEntryDialog";
import { handleSignalRTrigger } from "../../Utilities/CommonUtils";
import { entryId, formErrors, isSaving, template, templateId } from "../Manage/EditEntrySignals";
import { showEditSplitEntryWindow, showSplitEntryDialog } from "../View/ViewEntrySignals";

export const EditSplitEntryWindow = () => {
  const [event, setEvent] = useState(null);
  const buttonValidationMessage = "There are missing required fields";

  if (!showEditSplitEntryWindow.value) return null;

  const handleCommitClick = (e) => {
    const isFormInvalid = Object.values(formErrors.value).some(
      (sectionErrors) => sectionErrors.length > 0
    );
    if (isFormInvalid) {
      return;
    }

    setEvent(e);
    showSplitEntryDialog.value = true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showSplitEntryDialog.value = false;
    isSaving.value = true;

    try {
      const templateData = { ...template.value };

      for (const section of templateData.sections) {
        for (const field of section.fields) {
          if (field.fieldType === "ContinuousComments") {
            let comments = JSON.tryParse(field.value, []);

            comments.forEach((c) => {
              if (c.isTemporary) {
                delete c.isTemporary;
              }
            });

            field.value = JSON.stringify(comments);
          }
        }
      }

      const formData = {
        id: entryId.value || "",
        actionId: templateData.actionId || null,
        entryAuthor: templateData.entryAuthor ? templateData.entryAuthor : userEmail.value,
        templateId: templateId.value,
        sections: templateData.sections,
        _ts: templateData._ts,
        createdDate: templateData.createdDate,
      };

      if (formData.id) {
        const newEntries = { ...userEntries.value };
        const entryIndex = newEntries[templateId.value].findIndex(
          (entry) => entry.id === formData.id
        );
        newEntries[templateId.value][entryIndex] = formData;

        // Update record
        await axios.put(
          `${process.env.REACT_APP_API_ENDPOINT}/api/Entry/${entryId.value}?userId=${
            userEmail.value
          }&templateSync=${template.value?.properties?.["TemplateSync"] ?? false}`,
          formData
        );
        await handleSignalRTrigger("UPDATE", "Entry", formData);

        userEntries.value = newEntries;
      }

      showEditSplitEntryWindow.value = false;
      isSaving.value = false;
    } catch (error) {
      console.log("Failed to submit update split record: ", error);
    }
  };

  return (
    <Window
      title={"Update Record"}
      onClose={() => (showEditSplitEntryWindow.value = false)}
      initialHeight={850}
      initialWidth={650}
    >
      <If condition={!isSaving.value}>
        <div
          style={{
            position: "sticky",
            top: "-12px",
            backgroundColor: "var(--atlas-bg-primary)",
            zIndex: 100,
            height: "3.5rem",
          }}
        >
          {/* Commit Button */}
          <Button
            themeColor="primary"
            disabled={Object.values(formErrors.value).some(
              (sectionErrors) => sectionErrors.length > 0
            )}
            onClick={(e) => {
              handleCommitClick(e);
            }}
          >
            Commit Update
          </Button>
          {Object.values(formErrors.value).some((sectionErrors) => sectionErrors.length > 0) >
            0 && <Error>{buttonValidationMessage}</Error>}
        </div>

        <form className="k-form">
          {/* Data */}
          <Section />
        </form>
        <Else>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Loader
              type="converging-spinner"
              themeColor="primary"
            />
          </div>
        </Else>
      </If>
      {showSplitEntryDialog.value && (
        <ConfirmSplitEntryDialog
          handleCancel={() => (showSplitEntryDialog.value = false)}
          handleConfirm={() => handleSubmit(event)}
        />
      )}
    </Window>
  );
};
